import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const CoilQuantityRow = ({ manifold }: Props) => {
  return <PortRow name="Coil Qty" manifold={manifold} getValue={room => room.numberOfPipesPerPort} />;
};
